import {
  ListHeadersKind,
  ListHeadersPayload,
  ListHeadersRepository,
} from '../domain/ListHeadersRepository';
import {
  query_dispatcher_get,
  sync_command_dispatcher,
} from '@/api/client';

export class ApiListHeadersRepository implements ListHeadersRepository {
  async get(
    kind: ListHeadersKind,
    userId: number | null,
    cdbId: number | null,
  ): Promise<ListHeadersPayload> {
    const data: any = await query_dispatcher_get.dispatch('facturae.get_list_headers', {
      kind,
      user_id: userId,
      cdb_id: cdbId,
    });
    const show = Array.isArray(data && data.show) ? data.show : [];
    const hide = Array.isArray(data && data.hide) ? data.hide : [];
    return { show, hide };
  }

  async save(
    kind: ListHeadersKind,
    userId: number | null,
    cdbId: number | null,
    payload: ListHeadersPayload,
  ): Promise<void> {
    await sync_command_dispatcher.dispatch('facturae.save_list_headers', {
      kind,
      user_id: userId,
      cdb_id: cdbId,
      payload,
    });
  }
}
